@if (!isLoading() && !hasError()) {
  @if (freightAvailable(); as freight) {
    <ion-grid
      fixed="true"
      class="ion-padding-vertical-0"
    >
      <ion-row>
        <ion-col size="12">
          @if (isFullyAvailable()) {
            <ion-button
              expand="block"
              size="large"
              color="success"
              [disabled]="actionsDisabled()"
              (click)="acceptAvailableFreight()"
            >
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/handshake_24dp.svg"
              ></ion-icon>
              {{ 'market.accept_freight' | translate }}
            </ion-button>
          } @else if (isAvailableWithConditions()) {
            <ion-button
              expand="block"
              size="large"
              color="primary"
              [disabled]="actionsDisabled()"
              (click)="showInterestOnAssignedFreight()"
            >
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/check_24dp.svg"
              ></ion-icon>
              {{ 'market.interested_on_this_freight' | translate }}
            </ion-button>
          } @else {
            <ion-button
              expand="block"
              size="large"
              color="primary"
              [disabled]="actionsDisabled()"
              (click)="showInterestOnAssignedFreight()"
            >
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/favorite_24dp.svg"
              ></ion-icon>
              {{ 'market.interested_on_freight' | translate }}
            </ion-button>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  }
}
